(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["media-import-details"] && !Shopify.designMode) return;
  try {
    class MediaImportDetails extends HTMLElement {
    connectedCallback() {
      this.productInformation = this.closest('[id*="ProductInformation-"]');
      this.productInformation?.addEventListener('shopify:product:select', this.handleProductSelect);

      const output = this.querySelector('[data-shipping-date]');
      if (!output) return;

      const workingDays = Number(this.dataset.workingDays || 15);
      const shippingDate = new Date();
      shippingDate.setHours(12, 0, 0, 0);

      let addedDays = 0;
      while (addedDays < workingDays) {
        shippingDate.setDate(shippingDate.getDate() + 1);
        const day = shippingDate.getDay();
        if (day !== 0 && day !== 6) addedDays += 1;
      }

      const year = shippingDate.getFullYear();
      const month = String(shippingDate.getMonth() + 1).padStart(2, '0');
      const day = String(shippingDate.getDate()).padStart(2, '0');
      const locale = document.documentElement.lang || 'en-ZA';

      output.dateTime = `${year}-${month}-${day}`;
      output.textContent = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(shippingDate);
    }

    disconnectedCallback() {
      this.productInformation?.removeEventListener('shopify:product:select', this.handleProductSelect);
    }

    handleProductSelect = (event) => {
      event.promise
        .then(({ detail }) => {
          if (!detail?.resource || (detail.productId && detail.productId !== this.dataset.productId)) return;

          const eanUpcRow = this.querySelector('[data-ean-upc-row]');
          const eanUpc = this.querySelector('[data-ean-upc]');
          const variantSku = detail.resource.sku || '';

          const blurayLink = this.querySelector('[data-bluray-link]');
          if (blurayLink) {
            blurayLink.href = variantSku
              ? `https://www.blu-ray.com/search/?quicksearch=1&quicksearch_country=all&section=all&quicksearch_keyword=${encodeURIComponent(variantSku)}`
              : 'https://www.blu-ray.com/';
          }

          if (!eanUpcRow || !eanUpc) return;
          eanUpc.textContent = variantSku;
          eanUpcRow.hidden = !variantSku;
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[media-import-details] Variant update failed:', error);
        });
    };
  }

  if (!customElements.get('media-import-details')) {
    customElements.define('media-import-details', MediaImportDetails);
  }
  } catch(e) { console.error(e); }
})();

})();
